import { schema } from "normalizr";

export const expositionOrderPreviewSchema = new schema.Entity("expositionOrderPreviews");
export const expositionOrderSchema = new schema.Entity("expositionOrders");
